export default __webpack_public_path__ + "static/media/Ies_Panel2.af506579.jpg";